import 'react-native-image-keyboard'
import App from './src/app'

export default App
